import './Card.scss';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const Card = ({ type, title, subtitle, text, image }) => {
  const navigate = useNavigate();

  const normalizedTitle = title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const handleButtonClick = (button) => {
    if (button.plan) {
      navigate(`/servicios#${normalizedTitle}`);
    } else {
      navigate(button.link);
    }
  };

  return (
    <div className={`card ${type} ${normalizedTitle}`} onClick={() => handleButtonClick({ plan: type === 'melts', subtitle })}>
      {type === 'melts' ? (
        <div
          className={`card--${type}`}
          data-aos="fade-right"
        >
          <div className='card-title'>
            <h2>{title}</h2>
            <p>{subtitle}</p>
          </div>
        </div>
      ) : (
        <>
          <div className='top'>
            <img src={`/images/testimony/${image}`} alt="Testimonio" width="60" height="60" loading='lazy' />
            <div className='top-title'>
              <h3>{title}</h3>
              <p>{subtitle}</p>
            </div>
          </div>
          <div className='text'>
            <p dangerouslySetInnerHTML={{ __html: `"${text}"` }} />
          </div>
        </>
      )}
    </div>
  );
};

Card.propTypes = {
  type: PropTypes.oneOf(['melts', 'testimony']).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  elements: PropTypes.arrayOf(PropTypes.string),
  image: PropTypes.string,
};

export default Card;